export default __webpack_public_path__ + "images/34bc188b3f0f6622c994158f5460899c.svg";